const Blank = ({ children }: any) => <>{children}</>

export default Blank
